// Auto-save a "create" modal when the user closes it (X / backdrop / Esc):
// if the form was touched and its required fields validate, submit — identical
// to clicking Save, whose onSubmit already closes the modal on success.
// Otherwise run the caller's discard (the modal's existing close behaviour).
//
// `canSave` mirrors the modal's own Save-button guard (e.g. board/column
// selected, not already saving) so auto-save never fires a request the Save
// button itself would have blocked.
import type { FormikProps } from 'formik'

export async function saveOnClose(
  formik: FormikProps<any>,
  canSave: boolean,
  discard: () => void,
): Promise<void> {
  const errors = await formik.validateForm()
  if (formik.dirty && canSave && Object.keys(errors).length === 0) {
    formik.submitForm()
  } else {
    discard()
  }
}
